import { Slider } from '@upgrade/react-components';
import styled from 'styled-components';
import { mb, mt } from '@upgrade/react-components/Spacing/core';
import { Heading, Text } from '../../common/TypographyPublicSite';
import CTAButton from '../../common/CTAButton';

export const StyledControlsContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.xl} auto 0;
  width: 100%;
  max-width: 70rem;
`;

export const StyledSlider = styled(Slider)`
  margin-left: -1rem;
`;

export const StyledCurrency = styled(Heading)`
  > h2 {
    text-align: start;
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.number_md.fontSize};
    line-height: ${({ theme }) => theme.typography.sizes.text.desktop.number_md.lineHeight};
    font-weight: 500;
    @media (min-width: ${props => props.theme.mediaSm}) {
      text-align: center;
    }
  }
`;

export const StyledCTAButton = styled(CTAButton)`
  width: 100%;
`;

export const StyledChartContainer = styled.div`
  width: 100%;
  height: 20rem;
  margin: 0 auto ${({ theme }) => theme.spacing.md};
  max-width: 70rem;
`;

export const StyledBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  height: 17rem;
  ${mt('3xl')}
`;

export const Bar = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.palette.backgroundAccentPremierSavings};
  height: ${({ $height }) => `${$height}%`};
  width: 100%;
  max-width: 10rem;
  margin: 0 auto;
  ${mb('md')}
`;

export const StyledSavingsText = styled(Text)`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  top: -2.5rem;
`;
